import React, { useContext, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { RendererContext } from '@/components/FURenderkit'
import { Button } from 'antd-mobile'
import './index.scss'
import FUIcon from '../../Common/FUIcon'
import FacePupComp from './components/FacePupComp'
import { Collapse } from 'antd'
import FacePupCompHeader from './components/FacePupCompHeader'
import SaveAvatarBtn from '@/components/Common/SaveAvatarBtn'
import OverflowTooltip from '@/components/Common/OverflowTooltip'
import { CloudDownloadOutlined } from '@ant-design/icons'
import AvatarsTabContent from '../TalkSkill/components/AvatarsTabContent'
import { AvatarContext } from '@/components/RenderComp/Avatar'
import ColorBundle from '../CloudDressup/components/ColorBundle'
import BodyBundle from '../CloudDressup/components/BodyBundle'
import DressupBundle from '../CloudDressup/components/DressupBundle'
import { useAvatarEdit } from '@/hooks/useAvatarEdit'
import { useCollapse } from '@/hooks/useCollapse'
import classNames from 'classnames'

const AvatarDressup = (props) => {
    const { style, setInitDressupPart, setInitDressupType } = props
    const avatarTabRef = useRef<any>(null)
    const navigate = useNavigate()

    const { renderer } = useContext(RendererContext)
    const { avatarConfig } = useContext(AvatarContext)
    const {
        currentItems,
        gender,
        controlData,
        meshPoints,
        bodyPitchs,
        faceData,
        bodyData,
        clothesData,
        selectedDressupType,
        setMeshPoints,
        setBodyPitchs,
        dispatchTableData,
        selectedPartInControlData,
        selectedTypeInCurrentPart,
        currentFacepup,
        setSelectedDressupType,
        setSelectedTypeInCurrentPart,
        selectedDressupPart,
        setSelectedDressupPart,
        activeCollapsePanels,
        setActiveCollapsePanels,
        handleTypeSelect,
    } = useAvatarEdit(
        true,
        'my',
        avatarConfig,
    )
    const [collapse, setCollapse] = useCollapse(renderer?.resize)

    const toCloud = () => {
        setInitDressupPart(selectedDressupPart)
        setInitDressupType(selectedDressupType)
        navigate(`${process.env.REACT_APP_HOMEPAGE}/material`)
    }

    return (
        <div style={style} className="dressup-controller">
            <SaveAvatarBtn
                className="capture-btn"
                avatarTabRef={avatarTabRef}
            />
            <div className="dressup-part-selector">
                {
                    controlData.map(({
                        name,
                        normalIcon,
                        selectedIcon,
                        selectedColor,
                    }) => (
                        <FUIcon
                            className="dressup-part"
                            key={name}
                            style={{
                                'backgroundColor':
                                    selectedDressupPart === name ? selectedColor : '#fff',
                            }}
                            size="56px"
                            name={selectedDressupPart === name ? selectedIcon : normalIcon}
                            onClick={() => setSelectedDressupPart(name)}
                        />
                    ))
                }
            </div>
            <div className={
                classNames({
                    'dressup-pannel': true,
                    'hide': collapse
                })
            }>
                {
                    selectedDressupPart && selectedPartInControlData?.length > 1 && (
                        <div className="type-wrap better-scroll">
                            <div className="type-container">
                                {
                                    selectedPartInControlData.map(
                                        ({
                                            name,
                                            label,
                                            normalIcon,
                                            selectedIcon
                                        }) => (
                                            <div
                                                className={
                                                    `flex-center-align face-component ${selectedDressupType === name ? 'active' : ''}`
                                                }
                                                style={{
                                                    borderRadius: '16px',
                                                    flexDirection: 'column',
                                                    'backgroundColor': selectedDressupType === name
                                                        ? '#E0E0F6'
                                                        : '',
                                                }}
                                                onClick={() => handleTypeSelect(name)}
                                            >
                                                <FUIcon
                                                    key={name}
                                                    name={selectedDressupType === name ? selectedIcon : normalIcon}
                                                    size="32px"
                                                />
                                                <span style={{ fontSize: '12px' }}>{label}</span>
                                            </div>
                                        )
                                    )
                                }
                            </div>
                        </div>
                    )
                }
                <div className='handler-wrap better-scroll'>
                    {
                        currentFacepup && currentFacepup.length > 1 && (
                            <div className='collapse-controllers'>
                                {
                                    selectedDressupPart && selectedDressupType && selectedTypeInCurrentPart && (
                                        <span
                                            className={activeCollapsePanels[0] === '1' ? 'active' : ''}
                                            onClick={() => setActiveCollapsePanels(['1'])}
                                        >
                                            {selectedTypeInCurrentPart.label}
                                        </span>
                                    )
                                }
                                {
                                    currentFacepup.map((facepup) => {
                                        return (
                                            <span
                                                className={activeCollapsePanels[0] === facepup.key ? 'active' : ''}
                                                onClick={() => setActiveCollapsePanels([facepup.key])}
                                            >
                                                {facepup.displayName}
                                            </span>
                                        )
                                    })
                                }
                            </div>
                        )
                    }

                    <Collapse
                        accordion
                        className='custom-collapse better-scroll'
                        activeKey={activeCollapsePanels}
                        onChange={(key) => {
                            setActiveCollapsePanels([key as string])
                        }}
                    >
                        {
                            selectedDressupPart && selectedDressupType && selectedTypeInCurrentPart && (
                                <Collapse.Panel
                                    key="1"
                                    header={
                                        <FacePupCompHeader
                                            name={selectedTypeInCurrentPart.label}
                                            Icon={
                                                <FUIcon
                                                    size="24px"
                                                    name={selectedTypeInCurrentPart.normalIcon}
                                                    style={{ marginRight: '8px' }}
                                                />
                                            }
                                        />
                                    }
                                    className='custom-collapse-item area-wrap'
                                >
                                    <div className='component-area better-scroll'>
                                        {
                                            selectedDressupType === 'my' ? (
                                                <AvatarsTabContent ref={avatarTabRef} />
                                            ) : (
                                                <>
                                                    <div className='component-list'>
                                                        {
                                                            currentItems.map((item) => {
                                                                if (selectedTypeInCurrentPart.type === 'color') {
                                                                    return (
                                                                        <ColorBundle
                                                                            item={item}
                                                                            faceData={faceData}
                                                                            selectedDressupPart={selectedDressupPart}
                                                                            setSelectedDressupPart={setSelectedDressupPart}
                                                                            setSelectedDressupType={setSelectedDressupType}
                                                                            selectedTypeInCurrentPart={selectedTypeInCurrentPart}
                                                                            setSelectedTypeInCurrentPart={setSelectedTypeInCurrentPart}
                                                                        />
                                                                    )
                                                                } else if (selectedTypeInCurrentPart.type === 'bundle' && item.icon_url) {
                                                                    return (
                                                                        <DressupBundle
                                                                            item={item}
                                                                            mode={'local'}
                                                                            currentItems={currentItems}
                                                                            faceData={faceData}
                                                                            clothesData={clothesData}
                                                                            dispatchTableData={dispatchTableData}
                                                                            selectedDressupPart={selectedDressupPart}
                                                                            setSelectedDressupPart={setSelectedDressupPart}
                                                                            setSelectedDressupType={setSelectedDressupType}
                                                                            selectedDressupType={selectedDressupType}
                                                                            selectedTypeInCurrentPart={selectedTypeInCurrentPart}
                                                                            setSelectedTypeInCurrentPart={setSelectedTypeInCurrentPart}
                                                                            controlData={controlData}
                                                                        />
                                                                    )
                                                                } else if (selectedTypeInCurrentPart.type === 'conf') {
                                                                    return (
                                                                        <BodyBundle
                                                                            item={item}
                                                                            bodyData={bodyData}
                                                                            dispatchTableData={dispatchTableData}
                                                                            selectedDressupPart={selectedDressupPart}
                                                                            setSelectedDressupPart={setSelectedDressupPart}
                                                                            setSelectedDressupType={setSelectedDressupType}
                                                                            selectedTypeInCurrentPart={selectedTypeInCurrentPart}
                                                                            setSelectedTypeInCurrentPart={setSelectedTypeInCurrentPart}
                                                                            bodyPitchs={bodyPitchs}
                                                                            setBodyPitchs={setBodyPitchs}
                                                                        />
                                                                    )
                                                                }
                                                                return null
                                                            })
                                                        }
                                                    </div>
                                                    {
                                                        selectedTypeInCurrentPart.type === 'bundle' && (
                                                            <div className='cloud-link' onClick={toCloud}>
                                                                <CloudDownloadOutlined /> 更多云资源下载
                                                            </div>
                                                        )
                                                    }
                                                </>
                                            )
                                        }
                                    </div>
                                </Collapse.Panel>
                            )
                        }
                        {
                            currentFacepup.map((facepup) => {
                                return (
                                    <Collapse.Panel
                                        key={facepup.key}
                                        header={
                                            <FacePupCompHeader
                                                name={facepup.displayName}
                                                Icon={
                                                    facepup.icon ?
                                                        <FUIcon
                                                            size="24px"
                                                            name={facepup.icon(gender)}
                                                            style={{ marginRight: '8px' }}
                                                        /> : null
                                                }
                                            />
                                        }
                                        className='custom-collapse-item'
                                    >
                                        <FacePupComp
                                            facepup={facepup}
                                            selectedTypeInCurrentPart={selectedTypeInCurrentPart}
                                            meshPoints={meshPoints}
                                            bodyPitchs={bodyPitchs}
                                            setMeshPoints={setMeshPoints}
                                            setBodyPitchs={setBodyPitchs}
                                        />
                                    </Collapse.Panel>
                                )
                            })
                        }

                    </Collapse>
                </div>

            </div>
            {
                (
                    <>
                        <Button
                            className="apply"
                            size="small"
                            onClick={() => setCollapse(!collapse)}
                        >
                            收起
                        </Button>
                    </>
                )
            }
        </div>
    )
}

export default AvatarDressup
